/**
 * Created by puhui on 2016/12/12.jquery.pager.js
 */
require('./page.scss');

(function($){
  var ms = {
    init:function(obj,args){
      return (function(){
        ms.fillHtml(obj,args);
        ms.bindEvent(obj,args);
      })();
    },
    //生成html
    fillHtml:function(obj,args){
      return (function(){
       var pagenumber = parseInt(args.pagenumber);
       var pagecount = parseInt(args.pagecount);
       var endPoint = parseInt(args.endPoint);
       var $pager = $('<ul class="pages"></ul>');

        $pager.append(ms.renderButton('上一页', pagenumber, pagecount));
       var startPoint = 1;

        if(isNaN(endPoint)){
          var endPoint =5;
        }else{
          var endPoint=endPoint;
        }
      
        if (pagenumber > 4) {
            startPoint = pagenumber-2;
            endPoint = pagenumber +2;
        }

        if (endPoint > pagecount) {
            startPoint = pagecount - 4;
            endPoint = pagecount;
        }

        if (startPoint < 1) {
            startPoint = 1;
        }

        for (var page = startPoint; page <= endPoint; page++) {

            var currentButton = $('<li class="page-number" rel="' + (page) + '">' + (page) + '</li>');

            page == pagenumber ? currentButton.addClass('pgcurrent') : currentButton.click(function() { /*buttonClickCallback(this.firstChild.data);*/});
            currentButton.appendTo($pager);
        }

        
        $pager.append(ms.renderButton('下一页', pagenumber, pagecount))
        
        obj.empty().append($pager);
        return $pager;
      
      })();
    },
    renderButton:function(buttonLabel, pagenumber, pagecount) {
        var destPage = 1;

        switch (buttonLabel) {
            case "first":
                destPage = 1;
                break;
            case "上一页":
            var $Button = $('<li class="pgnext pg-up" rel="' + buttonLabel + '"></li>');
                destPage = pagenumber - 1;
                break;
            case "下一页":
            var $Button = $('<li class="pgnext pg-next" rel="' + buttonLabel + '"></li>');
                destPage = pagenumber + 1;
                break;
            case "last":
                destPage = pagecount;
                break;
        }

        // disable and 'grey' out buttons if not needed.
        if (buttonLabel == "first" || buttonLabel == "上一页") {
            pagenumber <= 1 ? $Button.addClass('pgempty'): $Button.click(function() { /*buttonClickCallback(destPage);*/ });
        }
        else {
            pagenumber >= pagecount ? $Button.addClass('pgempty'): $Button.click(function() { /*buttonClickCallback(destPage);*/});
        }

        return $Button;
    },

    //事件
    bindEvent:function(obj,args){
      return (function(){
        obj.on("click",".page-number",function(){
          var pagenumber = parseInt($(this).attr('rel'));
          var pgcurrent = parseInt(obj.find(".pgcurrent").attr('rel'));
          ms.fillHtml(obj,{"pagenumber":pagenumber,"pagecount":args.pagecount});
          
          if(parseInt(pagenumber)!=parseInt(pgcurrent)){
            if(typeof(args.buttonClickCallback)=="function"){
              args.buttonClickCallback(pagenumber);
            }
          }
           
        });
        //上一页
        obj.on("click",".pg-up",function(){
          var pagenumber = parseInt(obj.find(".pgcurrent").attr('rel'));
          if(parseInt(1)<parseInt(pagenumber)){
            ms.fillHtml(obj,{"pagenumber":pagenumber-1,"pagecount":args.pagecount});
            if(typeof(args.buttonClickCallback)=="function"){
              args.buttonClickCallback(pagenumber-1);
            }
          }
        });
        //下一页
        obj.on("click",".pg-next",function(){
          var pagenumber = parseInt(obj.find(".pgcurrent").attr('rel'));
          
          if(args.pagecount>parseInt(pagenumber)){
            ms.fillHtml(obj,{"pagenumber":pagenumber+1,"pagecount":args.pagecount});
            if(typeof(args.buttonClickCallback)=="function"){
              args.buttonClickCallback(pagenumber+1);
            }
          }

        });

      })();
    }
  }
  $.fn.pager = function(options){
    var args = $.extend({
      pagenumber:1,
      pagecount:10,
      endPoint:5,
      buttonClickCallback : function(){

      }
      //pagenumber 为当前页码 //pagecount 为显示页数//endPoint 为显示几个页数
      //PageClick 为回调函数//pageclickednumber 为点击页码
    },options);
    ms.init(this,args);
    
  }
})(jQuery);


// WEBPACK FOOTER //
// ./static/common/page/page.js